import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-carbon-progress-bar',
  templateUrl: './carbon-progress-bar.component.html',
  styleUrls: ['./carbon-progress-bar.component.scss'],
})
export class CarbonProgressBarComponent {
  @Input() value: number = 0; // Valor de 0 a 100
  @Input() expired: boolean = false; // Se está expirado (muda a cor para vermelho)
  @Input() width: string = '200px'; // Largura fixa da barra

  get progressValue(): number {
    return Math.min(Math.max(this.value, 0), 100);
  }
}
